import "./Header.css";
import React from "react";

export default function Header() {
    return (
        <header>
            <h1>
                Drum Machine
            </h1>
        </header>
    );
}